
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15.016","height":"12.21"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_13799","data-name":"Group 13799","transform":"translate(-628.5 -266.37)","fill":"none","stroke":"#6b7786","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('g',{attrs:{"id":"Group_13795","data-name":"Group 13795"}},[_c('line',{attrs:{"id":"Line_377","data-name":"Line 377","y2":"7.199","transform":"rotate(45 -2.6 907.993)"}}),_c('line',{attrs:{"id":"Line_378","data-name":"Line 378","x1":"7.147","transform":"rotate(45 -7.817 895.399)"}})]),_c('line',{attrs:{"id":"Line_379","data-name":"Line 379","x1":"13.016","transform":"translate(629.5 277.58)"}})])])
          )
        }
      }
    